// extracted by mini-css-extract-plugin
export var flowchartContainer = "_g-0";